// Rights data dropdown components for managing writers, publishers, and PROs
export type { Pro, ProDropdownProps } from './pro-dropdown'
export { ProDropdown } from './pro-dropdown'
export type { Publisher, PublisherDropdownProps } from './publisher-dropdown'
export { PublisherDropdown } from './publisher-dropdown'
export type { Writer, WriterDropdownProps } from './writer-dropdown'
export { WriterDropdown } from './writer-dropdown'

// Writers management component (table-based UI for SPLITS_V2)
export { WritersManagement } from './writers-management'

// Unsaved changes warning dialog for Writers tab
export { UnsavedChangesDialog } from './unsaved-changes-dialog'
